export default __webpack_public_path__ + "static/media/team3.575c6438.png";